import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFolderOpen, faAddressBook, faListCheck, faPeopleGroup, faToolbox,
  faGraduationCap, faWindowRestore, faCommentDollar, faDownload, faUserGroup,
  faRightFromBracket, IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { setAuth } from '../../redux/authSlice';

interface Props {
  access: any;
  userInfo?: string;
  userEmail?: string;
}

// Разделы, которые НЕ вынесены в основные табы (Dashboard/Timesheets/Notifications).
// Гейтинг доступа — те же *_enabled поля, что и в Nav.tsx.
const MODULES: { path: string; label: string; icon: IconDefinition; bg: string; key: string }[] = [
  { path: '/docs', label: 'Docs', icon: faFolderOpen, bg: 'rgba(14,165,233,.15)', key: 'docs_enabled' },
  { path: '/crm', label: 'CRM', icon: faAddressBook, bg: 'rgba(236,72,153,.15)', key: 'crm_enabled' },
  { path: '/tasks', label: 'TasksNav', icon: faListCheck, bg: 'rgba(99,102,241,.15)', key: 'tasks_enabled' },
  { path: '/community', label: 'Community', icon: faPeopleGroup, bg: 'rgba(234,179,8,.15)', key: 'community_enabled' },
  { path: '/equipment', label: 'Equipment', icon: faToolbox, bg: 'rgba(245,158,11,.15)', key: 'equipment_enabled' },
  { path: '/training', label: 'Training', icon: faGraduationCap, bg: 'rgba(16,185,129,.15)', key: 'training_enabled' },
  { path: '/booking', label: 'Booking', icon: faWindowRestore, bg: 'rgba(13,148,136,.15)', key: 'booking_enabled' },
  { path: '/finance', label: 'Finance', icon: faCommentDollar, bg: 'rgba(124,58,237,.15)', key: 'finance_enabled' },
  { path: '/orders', label: 'Orders', icon: faDownload, bg: 'rgba(245,158,11,.15)', key: 'orders_enabled' },
  { path: '/hr', label: 'HR', icon: faUserGroup, bg: 'rgba(236,72,153,.15)', key: 'hr_enabled' },
];

const MobileMore: React.FC<Props> = ({ access, userInfo, userEmail }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const initials = (userInfo || '')
    .split(' ')
    .map((s) => s.trim()[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const logout = async () => {
    try {
      await axios.post('logout', {}, { withCredentials: true });
    } catch {
      // сессия всё равно закрывается локально
    } finally {
      axios.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('authToken');
      dispatch(setAuth(false));
      navigate('/login');
    }
  };

  const modules = MODULES.filter((m) => access?.[m.key] === true);

  return (
    <div className="flex flex-col gap-[12px]">
      <div className="dt-card-wrap flex items-center gap-[14px] p-[14px]">
        <div className="m-more-av">{initials || '—'}</div>
        <div className="min-w-0">
          <div className="text-[16px] font-extrabold text-[var(--text-color)] truncate">{userInfo || '—'}</div>
          <div className="text-[12px] text-[var(--text-color-calendar)] truncate">{userEmail}</div>
        </div>
      </div>

      <div className="section-label" style={{ margin: '4px 4px' }}>{t('More')}</div>
      <div className="m-more-grid">
        {modules.map((m) => (
          <button key={m.path} type="button" className="m-more-tile" onClick={() => navigate(m.path)}>
            <span className="m-more-ic" style={{ background: m.bg }}>
              <FontAwesomeIcon icon={m.icon} style={{ color: 'var(--text-color)' }} />
            </span>
            <span className="m-more-nm">{t(m.label)}</span>
          </button>
        ))}
      </div>

      <button type="button" className="m-more-logout" onClick={logout}>
        <FontAwesomeIcon icon={faRightFromBracket} />
        {t('Logout')}
      </button>
    </div>
  );
};

export default MobileMore;
